import { ReactComponent as FirstIcon } from 'src/assets/svg/widget-sites.svg';
import { ReactComponent as SecondIcon } from 'src/assets/svg/widget-warning.svg';
import { ReactComponent as ThirdIcon } from 'src/assets/svg/widget-success.svg';
// import { ReactComponent as FourthIcon } from 'src/assets/svg/widget-loudspeaker.svg';

export const steps = [
  {
    key: 'sitesCount',
    subTitle: 'widgetStep1.subTitle',
    icon: <FirstIcon aria-hidden="true" />,
  },
  {
    key: 'totalReports',
    subTitle: 'widgetStep2.subTitle',
    icon: <SecondIcon aria-hidden="true" />,
  },
  {
    key: 'resolvedReports',
    subTitle: 'widgetStep3.subTitle',
    icon: <ThirdIcon aria-hidden="true" />,
  },
  // {
  //   key: 'openIssues',
  //   key2: 'issuesResolved',
  //   subTitle: 'widgetStep4.subTitle', 
  //   icon: <FourthIcon aria-hidden="true" />,
  // },
];
